import Vue from 'vue';
import Vuex from 'vuex';
import user from './modules/user';
import manage from './modules/manage';
import observation from './modules/observation';
import getters from './getters';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    user,
    manage,
    observation
  },
  getters
});

export default store;
